import { ChatEntity } from './entity';
import { toLuxon } from '@app/api';
import { DateTime } from 'luxon';
import { omit } from 'lodash';

export class ChatUser extends ChatEntity {
  lastActive: any;
  lastActiveTime: any;

  constructor(data: any) {
    super(data);

    this.update(data);
  }

  update(data: any) {
    Object.assign(this, omit(data, ['created', 'createdTime']));

    if (data.lastActive) {
      this.lastActive = toLuxon(data.lastActive) || DateTime.now();
      this.lastActiveTime = this.lastActive.toMillis();
    }
  }
}
